import Component from '@glimmer/component'
import svgJar from 'ember-svg-jar/helpers/svg-jar'

interface FlowKitIconArgs {
  Args: {
    src: string
    description?: string
  }
  Element: HTMLSpanElement
}

/**
 * A component that displays an icon.
 *
 * @param src - The name of the icon to display
 * @param description - A description of the icon for accessibility
 */
export default class FlowKitIcon extends Component<FlowKitIconArgs> {
  <template>
    <span flow-kit-icon={{@src}} data-testid='flow-kit-icon' ...attributes>
      {{svgJar @src role='img' title=@src desc=@description}}
    </span>
  </template>
}
